// HOOKS
import { createContext } from "react";
import useSelected from "../../hooks/other/useSelected.other.hook";
import useGetManyProducts from "../../hooks/products/useGetMany.product";
import useCreateProduct from "../../hooks/products/useCreate.product";
import useUpdateProduct from "../../hooks/products/useUpdate.product";
import useDeleteProduct from "../../hooks/products/useDelete.product";
import useDeleteManyProducts from "../../hooks/products/useDeleteMany.product";
import useCreateManyProducts from "../../hooks/products/useCreateMany.product";

export const ProductsContext = createContext({
  products: [],
  setProducts: () => {},
  getProducts: () => {},
  metaData: {},
  setMetaData: () => {},
  productInput: {},
  setProductInput: () => {},
  query: {},
  setQuery: () => {},
  handleLimitChange: () => {},
  handlePageChange: () => {},
  handleSearch: () => {},
  handleSort: () => {},
  isLoading: false,
  error: null,
  createProduct: () => {},
  updateProduct: () => {},
  deleteProduct: () => {},
  deleteManyProducts: () => {},
  handleChange: () => {},
  selected: [],
  setSelected: () => {},
  removeSelected: () => {},
  resetSelected: () => {},
  addSelected: () => {},
  createProducts: () => {},
});

export const ProductsProvider = ({ children }) => {
  const {
    products,
    setProducts,
    getProducts,
    metaData,
    setMetaData,
    productInput,
    setProductInput,
    setQuery,
    query,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
    loading: isLoading,
    error,
  } = useGetManyProducts();
  const { selected, setSelected, removeSelected, resetSelected, addSelected } =
    useSelected();
  const { createProduct } = useCreateProduct();
  const { updateProduct } = useUpdateProduct();
  const { deleteProduct } = useDeleteProduct();
  const { deleteManyProducts } = useDeleteManyProducts();
  const { createManyProducts } = useCreateManyProducts();

  const handleChange = async (event) => {
    const { name, value, dataset } = event.target;
    const { id } = dataset;
    const updatedProduct = products?.find((product) => product._id === id);
    // Update product in state
    setProducts(
      products.map((product) =>
        product._id === id ? { ...product, [name]: value } : product
      )
    );
    // Update product in db
    await updateProduct({ _id: id, [name]: value });
  };

  const createProducts = async (products) => {
    const res = await createManyProducts(products);
    if (res) {
      setTimeout(() => {
        getProducts();
      }, 2000);
      return res.data.createProducts;
    } else {
      console.log(`Failed to create products: ${res.error.message}`);
    }
  };

  return (
    <ProductsContext.Provider
      value={{
        products,
        setProducts,
        getProducts,
        metaData,
        setMetaData,
        productInput,
        setProductInput,
        setQuery,
        query,
        handleLimitChange,
        handlePageChange,
        handleSearch,
        handleSort,
        isLoading,
        error,
        createProduct,
        updateProduct,
        deleteProduct,
        deleteManyProducts,
        handleChange,
        selected,
        setSelected,
        removeSelected,
        resetSelected,
        addSelected,
        createProducts,
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
};
